import React from "react";
import * as Mui from "@mui/material";
import { designColors, designFontFamily } from "services/constants/designTokens";

export const RequestEditHeader = ({
  title,
  modeLabel = "- Edit",
  subtitle = "Update request details",
}) => (
  <Mui.Box sx={{ minWidth: 0, flex: 1 }}>
    <Mui.Stack direction="row" spacing={0.75} alignItems="baseline">
      <Mui.Typography
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: designColors.slate800,
          fontFamily: designFontFamily,
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </Mui.Typography>
      <Mui.Typography
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: designColors.slate800,
          fontFamily: designFontFamily,
          lineHeight: 1.3,
          flexShrink: 0,
        }}
      >
        {modeLabel}
      </Mui.Typography>
    </Mui.Stack>
    <Mui.Typography
      sx={{
        mt: 0.25,
        fontSize: 13,
        color: designColors.slate600,
        fontFamily: designFontFamily,
      }}
    >
      {subtitle}
    </Mui.Typography>
  </Mui.Box>
);

export default RequestEditHeader;
